(() => {
  // 二重実行防止
  if (window.__rundoRentalCartGuard) return;
  window.__rundoRentalCartGuard = true;

  // ★レンタル判定：SKUが RENT- で始まるもの（あなたの運用に最適）
  const isRentalItem = (item) => {
    const sku = (item.sku || '').toUpperCase();
    if (sku.startsWith('RENT-')) return true;

    // 保険（必要なら残す）
    const title = (item.product_title || '');
    const type = (item.product_type || '').toLowerCase();
    if (type === 'rental') return true;
    if (title.includes('レンタル')) return true;

    return false;
  };

  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

  let running = false;

  const enforce = async () => {
    if (running) return;
    running = true;

    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      const cart = await res.json();

      const rentals = (cart.items || []).filter(isRentalItem);

      // レンタルが0 or 1なら、数量だけ1に強制（保険）
      if (rentals.length <= 1) {
        if (rentals.length === 1 && rentals[0].quantity !== 1) {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ id: rentals[0].key, quantity: 1 }),
          });
        }
        return;
      }

      // レンタルが複数ある場合：
      // 先頭の1点だけ残して、残りは削除（quantity=0）
      const keep = rentals[0];

      // まず残すものを1に固定
      if (keep.quantity !== 1) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: keep.key, quantity: 1 }),
        });
        await sleep(120);
      }

      // 残りを削除
      for (let i = 1; i < rentals.length; i++) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: rentals[i].key, quantity: 0 }),
        });
        await sleep(120);
      }

      // カートページは表示更新が追いつかないことがあるのでリロード（確実）
      // ※DawnがAjax更新できている場合でも、軽い再読込で状態が確実に一致します
      window.location.reload();
    } catch (e) {
      // 失敗しても購入導線を壊さない（黙って抜ける）
      console.warn('[RentalCartGuard] error', e);
    } finally {
      running = false;
    }
  };

  // 初回
  document.addEventListener('DOMContentLoaded', () => {
    enforce();
  });

  // カート内で数量変更や削除が行われたあとにもう一度効かせる（保険）
  // Dawnの実装差異があるので、広めに拾う
  document.addEventListener('change', (e) => {
    const el = e.target;
    if (!(el instanceof Element)) return;

    // cart内の quantity input / update ボタンなどで発火しがち
    if (el.closest('cart-items, cart-drawer-items, form[action*="/cart"]')) {
      setTimeout(enforce, 200);
    }
  }, true);

})();
